import { render } from "./DJfreeze.vue?vue&type=template&id=3f7c2e84&scoped=true"
import script from "./DJfreeze.vue?vue&type=script&lang=js"
export * from "./DJfreeze.vue?vue&type=script&lang=js"

import "./DJfreeze.vue?vue&type=style&index=0&id=3f7c2e84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f7c2e84"

export default script